module.exports = __webpack_public_path__ + "static/media/art_icon.1052c7ba.svg";